import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from 'prosci-ui';
import { CircleCheck } from '../../utils/icons';
import { useHubAppCopy } from '../../hooks';

interface CertificationSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onProceedToCheckout: () => void;
  matchedUserName?: string;
  loading?: boolean;
}

export const CertificationSuccessModal: React.FC<CertificationSuccessModalProps> = ({
  isOpen,
  onClose,
  onProceedToCheckout,
  loading = false
}) => {
  const hubAppCopy = useHubAppCopy();
  const copy = hubAppCopy('portalCopy')?.subscriptionCopy?.certification?.success;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="text-center">
        <DialogHeader className="flex flex-col items-center gap-4">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
            <CircleCheck className="h-8 w-8 text-green-600" />
          </div>
          <DialogTitle>{copy?.title || 'Verification Successful!'}</DialogTitle>
          <DialogDescription className="text-center">
            {copy?.description || 'Your information has been successfully verified. You now have access to this tier.'}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="sm:justify-center">
          <Button
            type="button"
            variant="default"
            onClick={onProceedToCheckout}
            disabled={loading}
          >
            {loading ? (copy?.buttons?.processing || 'Processing...') : (copy?.buttons?.continue || 'Continue to Payment')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CertificationSuccessModal;
